import { Card, Skeleton } from '@mui/material';
import { useWindowSize } from '@uidotdev/usehooks';
import { BaseSyntheticEvent, useEffect, useRef } from 'react';

const createBlobURL = (htmlContent: string): string => {
    const blob = new Blob([htmlContent], { type: 'text/html' });
    return URL.createObjectURL(blob);
};

interface AutoHeightIframeProps
    extends React.IframeHTMLAttributes<HTMLIFrameElement> {
    htmlContent?: string;
}

const AutoHeightIframe = (props: AutoHeightIframeProps) => {
    const { style, htmlContent, srcDoc, src, ...rest } = props;
    const ref = useRef<HTMLIFrameElement>(null);
    const loadingref = useRef<HTMLDivElement>(null);
    const blobUrlRef = useRef<string | null>(null);

    const { width } = useWindowSize(); // trigers a re-render when the window size changes

    useEffect(() => {
        if (htmlContent && !src) {
            blobUrlRef.current = createBlobURL(htmlContent);
        }

        return () => {
            if (blobUrlRef.current) {
                URL.revokeObjectURL(blobUrlRef.current);
            }
        };
    }, [htmlContent, src]);

    const setHeight = (e: BaseSyntheticEvent) => {
        const iframe = ref.current;

        if (iframe) {
            const height =
                iframe.contentDocument?.documentElement?.scrollHeight;
            iframe.height = height;
            iframe.style.display = 'block';
            loadingref.current.style.display = 'none';
        }
    };

    setHeight();

    return (
        <>
            <iframe
                ref={ref}
                height={0}
                style={{
                    width: '100%',
                    border: 0,
                    display: 'none',
                    borderRadius: 'inherit',
                    ...style,
                }}
                onLoad={setHeight}
                src={src || blobUrlRef.current || undefined}
                srcDoc={!src && !blobUrlRef.current ? htmlContent : undefined}
                {...rest}
            />
            <Card ref={loadingref}>
                <Skeleton variant="rectangular" height={300} />
            </Card>
        </>
    );
};

export default AutoHeightIframe;
